import styled from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE } from '../../fields.constants';

export const Card = styled.section`
  overflow: hidden;
  background: #fff;
  border: ${em(1)} solid ${PALETTE.line};
  border-radius: ${em(6)};
`;

export const Frame = styled.div`
  position: relative;
  height: ${em(150)};
  background: linear-gradient(155deg, #8a7a5c, #4e4433);
`;

export const Tile = styled.div`
  position: relative;
  height: 100%;
  margin: 0 auto;
  aspect-ratio: 1;
  overflow: hidden;
`;

export const Photo = styled.img`
  position: absolute;
  top: -16.667%;
  left: -11.111%;
  width: 488.889%;
  max-width: none;
  height: 488.889%;
`;

export const FrameNote = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: ${rem(12.5)};
  color: #ede3cc;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${em(8)};
  padding: ${em(6)} ${em(11)};
  font-size: ${rem(12.5)};
  border-top: ${em(1)} solid ${PALETTE.line};

  span {
    color: ${PALETTE.muted};
  }

  b {
    font-weight: 500;
    font-variant-numeric: tabular-nums;
  }
`;

export const Mono = styled.b`
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: ${rem(12)};
`;

export const Est = styled.span`
  font-size: ${rem(11.5)};
  font-style: italic;
  font-weight: 400;
  color: ${PALETTE.faint};
`;

export const Vetted = styled.div`
  display: flex;
  align-items: center;
  gap: ${em(6)};
  padding: ${em(8)} ${em(11)};
  font-size: ${rem(12.5)};
  color: ${PALETTE.brand};
  border-top: ${em(1)} solid ${PALETTE.line};
`;

export const Tick = styled.span`
  font-family: -apple-system, system-ui, 'Segoe UI', sans-serif;
`;

export const Message = styled.div`
  display: flex;
  align-items: center;
  gap: ${em(10)};
  padding: ${em(12)};
  font-size: ${rem(12.5)};
  color: ${PALETTE.muted};
`;

export const RiskSquare = styled.span`
  display: inline-block;
  width: ${em(10)};
  height: ${em(10)};
  margin-right: ${em(6)};
  background: ${({ $color }) => $color};
  border: ${em(1.5)} solid #fff;
  border-radius: ${em(2)};
  box-shadow: 0 0 0 ${em(1)} rgba(0, 0, 0, 0.25);
`;
